var _rect, _rect2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 400,
    viewBox: "0 0 600 400",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 400,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 580,
    height: 380,
    fill: "none",
    stroke: "#0099CC",
    strokeWidth: 12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Emblem",
    transform: "translate(300, 85)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 65,
    fill: "none",
    stroke: "#0099CC",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "curve",
    d: "M -55,0 A 45,45 0 0,1 55,0",
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fontWeight: 900,
    fill: "#D32F2F",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("textPath", {
    href: "#curve",
    startOffset: "70%",
    textAnchor: "middle"
  }, "\n    Randeva Advisory Services Pvt Ltd.\n  ")), /*#__PURE__*/React.createElement("circle", {
    r: 42,
    fill: "#E8D8B0",
    stroke: "#D32F2F",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: -32,
    y: 12,
    fontFamily: "Georgia, serif",
    fontSize: 32,
    fontStyle: "italic",
    fontWeight: "bold",
    fill: "#D32F2F"
  }, "R"), /*#__PURE__*/React.createElement("text", {
    x: -10,
    y: 12,
    fontFamily: "Georgia, serif",
    fontSize: 32,
    fontStyle: "italic",
    fontWeight: "bold",
    fill: "#0099CC"
  }, "A"), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 12,
    fontFamily: "Georgia, serif",
    fontSize: 32,
    fontStyle: "italic",
    fontWeight: "bold",
    fill: "#333333"
  }, "S"), /*#__PURE__*/React.createElement("text", {
    x: -25,
    y: 55,
    fontSize: 14,
    fill: "#1B5E20"
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 60,
    fontSize: 16,
    fill: "#D32F2F",
    textAnchor: "middle"
  }, "\u2605"), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 55,
    fontSize: 14,
    fill: "#1B5E20"
  }, "\u2605"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300, 220)",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    y: 0,
    fontFamily: "Brush Script MT, cursive",
    fontSize: 110,
    fill: "#D32F2F"
  }, "Randeva"), /*#__PURE__*/React.createElement("text", {
    y: 55,
    fontFamily: "Arial Black, sans-serif",
    fontSize: 36,
    fill: "#334155"
  }, "Advisory Services Pvt Ltd."), /*#__PURE__*/React.createElement("line", {
    x1: -240,
    y1: 75,
    x2: 240,
    y2: 75,
    stroke: "#D32F2F",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("text", {
    y: 110,
    fontFamily: "Arial, sans-serif",
    fontSize: 24,
    fontWeight: "bold",
    fill: "#334155"
  }, "\n      WA-116, 3RD Floor, Shakarpur, Delhi - 110092\n    "), /*#__PURE__*/React.createElement("text", {
    y: 150,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "#333333"
  }, "\n      Phone: 011 45969601\n    "))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg);
export default __webpack_public_path__ + "static/media/svg.0547af7e68ab17784ddb7a9a61516495.svg";
export { ForwardRef as ReactComponent };